import styled from "styled-components";

export const GroupFiltersListGroupBox = styled.div`  
  padding: 20px 0;
  border-bottom: 1px solid ${props => props.theme.colors.arenaTitleBottomDevider};
  
  &:first-of-type {
    padding-top: 0;
  }
`;